import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class WillsNoticeSearch extends BaseEntityModel {
  id?: number;
  estateId?: number;
  hasExistingSearch?: boolean;
  newSearchRequired?: boolean;

  constructor(model: Partial<WillsNoticeSearch> = {}) {
    super(model);

    this.id = model.id;
    this.estateId = model.estateId;
    this.hasExistingSearch = model.hasExistingSearch;
    this.newSearchRequired = model.newSearchRequired;
  }
}
